import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class CostComparisonService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  // example for other request
  // async getPlatformBrowserData(params: getPlatformBrowserDataParams): Promise<any> {
  //   return this.makeRequest('get', APIS.GET_PLATFORM_BROSWER_DATA(), { params });
  // }

  // async removeUnusedResource(params: any): Promise<any> {
  //   return this.makeRequest('delete', APIS.UNUSED_REMOVE(), params);
  // }

  // async resizeInstance(params: any): Promise<any> {
  //   return this.makeRequest('patch', APIS.RESIZE_INSTANCE(), params);
  // }

  async getMultiAccountsData(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_MULTI_ACCOUNT_DATA(), params);
  }
  // async getCategoryList(params: string): Promise<any> {
  //   return this.makeRequest('post', APIS.GET_CATEGORY_LIST(), params);
  // }
  async downloadMultiAccountReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_MULTI_ACCOUNT_REPORT(),
      params
    );
  }
}
